import { BaseModel } from './base.model'
import { AppTranslation } from 'models';

export class AppLocale extends BaseModel<AppLocale> {
  static DEFAULT_ATTRIBUTES = {
    main: false
  }

  name: string
  native: string
  main: boolean
  code: string
  translations: AppTranslation[]
  translationsCount: number
  textDirection: string

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/app-locale.model.ts